// !Important!
// NOTE - for any change in the below value, please make sure to update the tailwind comments at the usage touchpoints
// else utility classes would not be applied
export const BASE_HEADER_HEIGHT = 3.75; // 60px
const SEARCH_CONTAINER = 5.75;
const RIGHT_CONTAINER_TOP_PADDING = 1.5;

export const VENUE_STICKY_HEADER_HEIGHT = 7;

const NOTIFICATION_BANNER_HEIGHT = 2.75;
const NOTIFICATION_BANNER_HEIGHT_MOBILE = 1.5; // more 24px
const LOGIN_RIBBON_HEIGHT_MOBILE = 1.25; // more 20px

/**
 * Calculates the height of the header based on the visibility of the notification banner and the login ribbon
 */
export default function calcHeaderHeight(
  initialValue: number,
  isNotificationBannerVisible: boolean,
  isLoggedIn: boolean,
  isMobile?: boolean
) {
  let result = initialValue;
  if (isNotificationBannerVisible) {
    // adding 2.75rem to the header height to account for the notification banner
    result += NOTIFICATION_BANNER_HEIGHT;
    if (isMobile) {
      // adding 1.5rem to the header height to account for the notification banner
      result += NOTIFICATION_BANNER_HEIGHT_MOBILE;
    }
  }
  if (isLoggedIn) {
    // login ribbon
    result += LOGIN_RIBBON_HEIGHT_MOBILE;
  }

  return result;
}

/**
 * Gets some of the dynamic styles for right section SRP (map and below) based upon loggedin, notification banner)
 * IMPORTANT - why these comments are important for tailwind - https://flaviocopes.com/tailwindcss-cannot-generate-classes-dynamically/
 */
export function getRightContainerStyles(isLoggedIn: boolean, isNotificationBannerVisible: boolean) {
  return {
    mapExpanded: {
      // possible values of lg:h-[calc(100vh_-_9.5rem)], lg:h-[calc(100vh_-_12.25rem)], lg:h-[calc(100vh_-_13.5rem)], lg:h-[calc(100vh_-_10.75rem)]
      // possible values of xl:top-[9.5rem], xl:top-[12.25rem], xl:top-[13.5rem], xl:top-[10.75rem]
      top: calcHeaderHeight(BASE_HEADER_HEIGHT + SEARCH_CONTAINER, isNotificationBannerVisible, isLoggedIn),
      // possible values of top-[9.5rem], top-[13.75rem], top-[15rem], top-[10.75rem]
      mobileTop: calcHeaderHeight(BASE_HEADER_HEIGHT + SEARCH_CONTAINER, isNotificationBannerVisible, isLoggedIn, true)
    },
    mapCollapsed: {
      // possible values of xl:top-[11rem], xl:top-[13.75rem], xl:top-[15rem], xl:top-[12.25rem]
      top: calcHeaderHeight(
        BASE_HEADER_HEIGHT + SEARCH_CONTAINER + RIGHT_CONTAINER_TOP_PADDING,
        isNotificationBannerVisible,
        isLoggedIn
      ),
      // possible values of top-[11rem], top-[15.25rem], top-[16.5rem], top-[12.25rem]
      mobileTop: calcHeaderHeight(
        BASE_HEADER_HEIGHT + SEARCH_CONTAINER + RIGHT_CONTAINER_TOP_PADDING,
        isNotificationBannerVisible,
        isLoggedIn,
        true
      ),
      // possible values of h-[calc(100vh_-_9.5rem)], h-[calc(100vh_-_12.25rem)], h-[calc(100vh_-_13.5rem)], h-[calc(100vh_-_10.75rem)]
      height: calcHeaderHeight(BASE_HEADER_HEIGHT + SEARCH_CONTAINER, isNotificationBannerVisible, isLoggedIn)
    }
  };
}
